import { Popover } from '@headlessui/react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { useTranslate } from '../../../../hooks/useTranslate';
import type { GetTagsByMarketResult } from '../../../MarketPage/MarketPage.types';
import { Dropdown } from './components/Dropdown/Dropdown';
import { StyledButton } from './TagsMenu.styles';

type Props = {
  tags: GetTagsByMarketResult;
};

export const TagsMenu = ({ tags, ...rest }: Props) => {
  const { t } = useTranslate();

  return (
    <Popover {...rest}>
      <StyledButton>
        {t('explore.popularCategories')}

        <KeyboardArrowDownIcon fontSize="small" />
      </StyledButton>

      <Dropdown tags={tags} />
    </Popover>
  );
};
